export const accountLevel = (rate): 1 | 2 | 3 | 4 => {
  const _rate = parseInt(rate)
  if (_rate <= 3) return 1
  if (_rate <= 5) return 2
  if (_rate === 6) return 3
  if (_rate <= 8) return 4
  return 1
}
